import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('//cookies');

const consentGiven = namespaceAction('CONSENT_GIVEN');

export { consentGiven };
